import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { AdminDashboard } from "../../Objects/AdminDashboard/AdminDashboard"
import { ERequestType } from "../../Enum/ERequestType"
import { GetRequest } from "../../services/ApiClientService"

export const useGetAdminDashboard = () => {
  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetAdminDashboard = async (onSuccess: (data: AdminDashboard) => void) => {
    enableLoad()

    try {
      const response = await GetRequest<AdminDashboard>(API_ROUTES.ADMIN_DASHBOARD.GET, ERequestType.Admin)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new AdminDashboard(response.data ?? {}))
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "Erro ao carregar painel administrativo."
      setError("Painel administrativo", message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetAdminDashboard,
  }
}
